var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.$store.getters['Profile/loadingReferee'])?_c('v-overlay',{attrs:{"z-index":"10","color":"#000000","opacity":".6"}},[_c('v-progress-circular',{attrs:{"size":"100","width":"4","indeterminate":"","color":"primary"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }